





























































































import Vue from 'vue';
import Component from 'vue-class-component';
import * as soap from 'soap';
import genericapi  from '../assets/ts/genericAPIAxios';
import publicinquiryapi  from '../assets/ts/publicinquiryapi';

@Component
export default class EBiennialEmailUpdateSearch extends Vue {
  private showMaintenanceBanner : boolean = false;
  private maintenanceBannerMessage:string = '';
  private DOSIDNumber: string = '';
  private BusinessName: string = '';
  private errors = [];
  private label = [];
  private filingResponse: any = {};
  private SubmitterInfo: any = {};
  private validationConfigurationFromDB=[];
  private created() {
    console.log('Inside created of first page');
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
      });
    }
        console.log('Fetching configuration from database');
    genericapi.get('Generic/GetConfigurationData', {
      params: {
      group: 'CONFIGURATION',
      application: 'EBIENNIAL',
    },

    }).then((response: any) => {
      console.log(response);
      this.validationConfigurationFromDB = response.data;
      console.log('after getting the configuration values from database');
      console.log(this.validationConfigurationFromDB);
      this.maintenanceBannerMessage = this.getConfigurationValue('EBIENNIAL_MAINTENANCE_BANEER');
      this.showMaintenanceBanner = (this.getConfigurationValue('EBIENNIAL_SHOW_MAINTENANCE_BANNER') === 'true');
      console.log('show maintenance banner:'+this.showMaintenanceBanner);
      }).catch((error: any) => {
      // this.error = error
      console.log(error);
    });

  }
  private getLabelValue(label: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === label) {
          console.log('Matched if');
          return this.label[i][key];
        }
      }
    }
  }
   private getConfigurationValue(keyValue: string): string {
  console.log('keyValue passed:' + keyValue);
  for (let i = 0; i < this.validationConfigurationFromDB.length; i++) {
      for (const key in this.validationConfigurationFromDB[i] ) {
        //console.log( key + ' == ' +  this.errorsMessagesFromDB[i][key]);
        if (key === keyValue) {
          console.log('Matched if:'+this.validationConfigurationFromDB[i][key]);
          return this.validationConfigurationFromDB[i][key];
        }

      }
  }
}
   private getImageURL(columnname: string) {
     const images = require.context('@/assets/images/', true, /\.jpg$/);
     return images('./' + this.getLabelValue(columnname));
  }
  private fetchLabels() {
     return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);

      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private search(): void {
    const store = this.$store;
    const http = this.$http;
    this.errors.length = 0;
    if (this.empty(this.DOSIDNumber)) {
      console.log('DOS ID missing');
      this.errors.push('DOS ID missing.');
    }
    if (this.empty(this.BusinessName)) {
      console.log('Business name missing');
      this.errors.push('Business name required.');
    }
    if (this.errors.length) {
   console.log('Missing values');
   return;
  }
    http.post('Ebiennial/GetEBiennialSearchData', {
      // entityName: this.BusinessName,
      // searchReq:ebiennial,
            req: {
              dosId: this.DOSIDNumber,
              entityName: this.BusinessName.toUpperCase(),
            },
      // SubmitterInfo: this.SubmitterInfo
    }).then((response: any) => {
      response = response.data.eBiennialSearchResult;
      console.log(response);
      console.log('isSuccess:' + response.requestStatus);
      // this.searchEntity();

      if (response.requestStatus === 'Success' || (response.requestStatus === 'Fail' && response.errorMessage === 'Biennial Statement cannot be filed prior to the Filing Window Date')) {
          this.filingResponse = JSON.parse(JSON.stringify(this.$store.getters['ebiennial/EBiennialFiling']));
          console.log(this.filingResponse);
          this.filingResponse.dosId = response.dosid;
          this.filingResponse.entityName = response.entityName;
          this.filingResponse.entityType = response.entityType;
          this.filingResponse.feeAmount = response.feeAmount;
          this.filingResponse.filingPeriod = response.filingPeriod;
          this.filingResponse.emailForEBiennial = response.emailForNotification;
          store.commit('ebiennial/setEBiennialData', this.filingResponse);
          this.$router.push({ name: 'emailUpdate' });
      } else {
        this.errors.push(response.errorMessage);
      }

    }).catch((error: any) => {
      // this.error = error
      console.log(error);
      this.errors.push(error);
    });
  }
  private reset(): void {
        this.errors.length = 0;
        this.DOSIDNumber = '';
        this.BusinessName = '';
    return;
   }
  private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
}
